<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header title="Notifications"></app-sub-header>

                        <!-- <div class="margin-b" style="text-align: end;">
                            <button routerLink='/create-alerts' class="btn  main-backgroundcolor color">Create
                                Alert</button>
                        </div> -->

                    </div>
                </div>
                <app-no-results-found *ngIf="error == null && errorloading" title='Notification'></app-no-results-found>

                <div *ngFor="let props of (objArr | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: pageNo,
                    totalItems: totalItems
                  })">
                    <app-alert-card (click)="navigateToPartner(props)" *ngIf="loading" [size]=2 [data]="props"
                        [route]="jumptoScreen(props)"></app-alert-card>
                </div>

                <div *ngIf="!loading">
                    <div *ngFor="let props of arr">
                        <app-card-skelton></app-card-skelton>
                    </div>
                </div>



                <!-- <div *ngIf="!loading" >
                    <div *ngFor="let props of alertsArr">
                    <app-card-skelton ></app-card-skelton>
                    </div>

                </div> -->





                <div *ngIf="loading" class="col-md-12" style="text-align: center;">
                    <pagination-controls class="col s12 col-md-offset-3 my-pagination" *ngIf="objArr?.length > 0 "
                        (pageChange)="page = getNotification($event)" directionLinks="true" autoHide="false"
                        responsive="true" previousLabel="Previous" nextLabel="Next"
                        screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page">
                    </pagination-controls>
                </div>

            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>